import React from 'react';
import { Message } from '../types/chat';

interface ChatMessageProps {
  message: Message;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const { content, isUserMessage } = message;

  return (
    <div className={`message ${isUserMessage ? 'user-message' : 'ai-message'}`}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default ChatMessage; 